module.exports = __webpack_public_path__ + "static/media/last-sold-cars-blurred.ed518d20.png";